import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateUtilService } from 'gung-common';
import { Cart, CartRow, CartRowPrice, CartService, AuthService, CartsService, GungModalService, PriceService, Product, ProductService, SavedQuoteTableComponent, SavedQuoteTableService } from 'gung-standard';
import { Observable, first, forkJoin, map, filter } from 'rxjs';

@Component({
  selector: 'tylo-helo-saved-quote-table',
  templateUrl: './helo-saved-quote-table.component.html',
  styleUrl: './helo-saved-quote-table.component.css'
})
export class HeloSavedQuoteTableComponent extends SavedQuoteTableComponent {
  mapData: {
    [id: string]: {
      qty: number;
      product: Product;
      productId: string;
      row?: any
    }[];
  } = {};
  public isUser: boolean;

  constructor(
    protected translateService: TranslateService,
    protected cartsService: CartsService,
    protected productService: ProductService,
    protected cartService: CartService,
    protected modalService: GungModalService,
    public dateUtilService: DateUtilService,
    protected savedQuoteTableService: SavedQuoteTableService,
    protected priceService: PriceService,
    protected authService: AuthService
  ) {
    super(
      translateService,
      cartsService,
      productService,
      cartService,
      modalService,
      dateUtilService,
      savedQuoteTableService
    );

    this.authService.getRoles().pipe(filter(roles => !!roles), first()).subscribe(roles => this.isUser = roles.indexOf('ADMIN') === -1 && roles.indexOf('SALES') === -1)
  }

  protected fetchData(cart: Cart): Observable<{ qty: number; product: Product; productId: string, row: CartRow, price: CartRowPrice }[]> {
    const ids = cart.data.rows.map(row => row.productId || row.id);
    return forkJoin({
      products: this.productService.getProductsByIds(ids).pipe(first()),
      prices: forkJoin(cart.data.rows.map(row => this.priceService.getCartRowPriceObservable(row).pipe(first())))
    }).pipe(
      map(({ products, prices }) => {
        const data: { qty: number; product: Product; productId: string, row: CartRow, price: CartRowPrice }[] = [];

        cart.data.rows.map(row => {
          const qty = row.qty || row.quantity;
          // in case product was not presented in the response
          // it means the product is excluded (due to blocked, not belong to flow, removed)
          const product: Product = products.find(p => p.id === (row.productId || row.id));

          if (product) {
            data.push({
              qty,
              product,
              productId: row.productId || row.id,
              row,
              price: (prices as CartRowPrice[]).find(p => p.productId === (row.productId || row.id))
            });
          } else {
            // To add the productId to list of excluded ids when loading cart
            data.push({
              qty,
              product: undefined,
              productId: row.productId || row.id,
              row,
              price: (prices as CartRowPrice[]).find(p => p.productId === (row.productId || row.id))
            });
          }
        });

        return data;
      })
    );
  }

  protected setMappedData(cartId: string, data: { qty: number; product: Product; productId: string, row: CartRow, price: CartRowPrice }[]): void {
    // include only all the row whose product is not excluded
    if (!this.mapData[cartId]) {
      this.mapData[cartId] = data
        .filter(row => !!row.product)
        .map(row => {
          return {
            qty: row.qty,
            product: row.product,
            productId: row.productId,
            row: {
              ...row.row,
              extra: row.row.extra || {}
            },
            rrp: row.price.customerGrossPrice.value
          };
        });
    }
  }

  updateCart(cart: Cart) {
    this.cartsService.updateSavedCart(cart).subscribe(_ => { })
  }
}
